import { connect } from "react-redux";
import React, { useState, useMemo } from "react";
import ReactTable from 'react-table';
import { Row, Col, Button, Input, Container, Card, Label, CardBody } from "reactstrap";
import CustomModal from "../../../../../../Components/Modals/CustomModal";
import ProductDetailsAboveThousand from "./ProductDetailsAboveThousand";



function LargeproductListAboveThousand(props) {
    const [isOpenProductDetails,setIsOpenProductDetails]=useState(false)
    const [selectedProduct, setSelectedProduct] = useState(null);
//   const [isOpenChaild, setIsOpenChaild] = useState(false);


    const handleProductDetails = (rowData) => {
        setSelectedProduct(rowData);
        setIsOpenProductDetails(true);
    };
    
    const groupedData = props.filterWiseProductList || [];

    const columns = [
        // {
        //     Header: 'Image',
        //     accessor: 'itemImage',
        //     // width:80,
        //     Cell: (cellInfo) => (
        //         <div className="d-flex justify-content-center w-100" onClick={()=>handleImageDetails(cellInfo.value)}>
        //             <p className=" m-0 cursor-pointer" >view</p>
        //         </div>
        //     )
        // },
        {
            Header: 'Parent Asin',
            accessor: 'parentProduct',
            width:120,
            Cell: (cellInfo) => (
                <div className="d-flex justify-content-center w-100">
                    <p className=" m-0 " >{cellInfo.value}</p>
                </div>
            )
        },
        {
            Header: 'Child Asin',
            accessor: 'asin',
            width:120,
            Cell: (cellInfo) => (
                <div className="d-flex justify-content-center w-100">
                    <p className=" m-0 " >{cellInfo.value}</p>
                </div>
            )
        },
        {
            Header: 'Title',
            accessor: 'productTitle',
            Cell: ({ original }) => (
                <div
                    className="d-flex justify-content-start w-100"
                    style={{ 
                        cursor: original.isParentProduct ? "default" : "pointer",  // no pointer for parent
                        color: original.isParentProduct ? "#4f4d4d" : "#007bff",   // no blue for parent
                    }}
                    onClick={() => {
                        if (!original.isParentProduct) {        //  only open if NOT parent
                            handleProductDetails(original);
                        }
                    }}
                >
                    <p className="m-0">{original.productTitle}</p>
                </div>
            )
            
          },
          
        {
            Header: 'Reviews',
            accessor: 'ratingVotes',
            width:80,
            Cell: (cellInfo) => (
                <div className="d-flex justify-content-center w-100">
                    <p className=" m-0 " >{cellInfo.value}</p>
                </div>
            )
        },
        {
            Header: 'Rating',
            accessor: 'itemRating',
            width: 80,
            Cell: (cellInfo) => (
                <div className="d-flex justify-content-center w-100">
                    <p className=" m-0 " >{cellInfo.value}</p>
                </div>
            )
        },

    ]   
    return (
        <>
            <Row>
                <Col md={12}>

                    <ReactTable
                        data={groupedData}
                        columns={columns}
                        className="-fixed -highlight -striped mt-2"
                        getTheadProps={() => {
                            return {
                                style: {
                                    overflowY: "hidden",
                                    background: "#B1FA63",
                                    color: "#243837",
                                },
                            };
                        }}
                        getTrProps={(state, rowInfo) => {
                           
                            if (rowInfo && rowInfo.original && rowInfo.original.isParentProduct
                            ) {
                              return {
                                style: {
                                  backgroundColor: '#dfd7ff', 
                                },
                              };
                            }
                            return {};
                          }}
                        defaultPageSize={10}
                        noDataText={"No Data Found."}
                    />
                </Col>

            </Row>

            <CustomModal
    // header={selectedProduct && selectedProduct.productTitle}
    header={<p title={selectedProduct && selectedProduct.productTitle} className="comment-paragraph-Product-Name">{selectedProduct && selectedProduct.productTitle}</p>}

    isOpen={isOpenProductDetails}
    toggle={() => setIsOpenProductDetails(!isOpenProductDetails)}
    size={"lg"}
>
    {selectedProduct && (
        <ProductDetailsAboveThousand
        parentProducts={props.parentProducts}
        childProducts={props.childProducts}

        selectedProduct={selectedProduct}
        updateProductManagement={props.updateProductManagement}
        storeIntegerID={props.storeIntegerID}
        token={props.token}
        UserPermission={props.UserPermission}
     />
    )}
</CustomModal>


        </>

    )
    
}
const mapStateToProps = (state) => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        status: state.loggedUser.status,
        storeOverview: state.accountOverview.store.storeOverview,
        adProfiles: state.accountOverview.landing.adProfiles,
        weeklyReport: state.accountOverview.store.weeklyReport,
        ProductPerformanceReport: state.accountOverview.store.ProductPerformanceReport,
        TargetPerformanceReport: state.accountOverview.store.TargetPerformanceReport,
        StoreOverviewReport: state.accountOverview.store.StoreOverviewReport,
        WeeklySalesReport: state.accountOverview.store.WeeklySalesReport,
        SalesTrendsReport: state.accountOverview.store.SalesTrendsReport,
        WeeklySearchTermReport: state.accountOverview.store.WeeklySearchTermReport,
        CampaignPerformanceReport: state.accountOverview.store.CampaignPerformanceReport,

        storeLoading: state.accountOverview.store.loading,
        status: state.accountOverview.store.status,
        UserPermission: state.accountOverview.store.StoreUserPermission,
        error: state.loggedUser.error,
        newUser: state.loggedUser.newUser,
        needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
        user: state.LWA.user,
        isAuth: state.LWA.isAuth,
        enableMobileMenu: state.theme.enableMobileMenu,
        enableClosedSidebar: state.theme.enableClosedSidebar,
        storeProducts: state.accountOverview.store.storeProducts,
        parentProducts: state.accountOverview.store.parentProducts,
        orphanProducts: state.accountOverview.store.orphanProducts,
        ProductTargetingReport: state.accountOverview.store.ProductTargetingReport,

        storeCampaigns: state.accountOverview.store.storeCampaigns,
        unclaimedCampaigns: state.accountOverview.store.unclaimedCampaigns,
        metricData: state.accountOverview.store.metricData,
        linkedToMRP: state.accountOverview.store.storeOverview.linkedToMRP,
    };
}
export default connect(mapStateToProps)(LargeproductListAboveThousand);